import React from 'react';
import { observer } from 'mobx-react-lite';

import { ReflexContainer, ReflexSplitter, ReflexElement } from 'react-reflex';

import 'react-reflex/styles.css';

import Area from './Area';
import { getIsNestedContainer } from '../stores/utils/NodeUtils';

const renderContainerNode = (node, hash, depth) => {
  return (
    <ReflexContainer key={node.id} orientation={node.type}>
      {node.nodeIds.map((childId) =>
        renderNode(hash.get()[childId], hash, depth + 1)
      )}
    </ReflexContainer>
  );
};

const renderElementNode = (node, hash, depth) => {
  const childNode = hash.get()[node.nodeIds[0]];
  const newDepth = depth + 1;
  const { flex } = node.meta;
  return (
    <ReflexElement key={node.id} flex={flex}>
      {getIsNestedContainer(childNode)
        ? renderContainerNode(childNode, hash, newDepth)
        : renderAreaNode(childNode, newDepth)}
    </ReflexElement>
  );
};

const renderSplitterNode = (node, depth) => <ReflexSplitter key={node.id} />;

const renderAreaNode = (node, depth) => <Area node={node} depth={depth} />;

const renderNode = (node, hash, depth) => {
  if (!node) return null;

  switch (node.type) {
    case 'horizontal':
    case 'vertical':
      return renderContainerNode(node, hash, depth);
    case 'element':
      return renderElementNode(node, hash, depth);
    case 'split':
      return renderSplitterNode(node, depth);
    case 'area':
      return renderAreaNode(node, depth);
    default:
      break;
  }
};

const AreaTree = observer(({ node, hash, depth }) => {
  return renderNode(node, hash, depth);
});

export default AreaTree;
